import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'updateListFilter'
})
export class MassPromoPipe implements PipeTransform {

  transform(items: any, filter: any, promoStatus: any, promoChecked: any, num?: any,): any {
    var flag = false;
    
    if (items && items.length) {
      return items.filter(item => {

        if(promoStatus.length > 0){
          for(var i = 0; i <= promoStatus.length - 1; i++){
            if(promoStatus && item.promoStatus.toString().indexOf(promoStatus[i].id.toString()) === 0){
              flag = true; break;
            } else {
              flag = false;
            }
          }
          return flag;
        }

        if(promoChecked.length > 0){
          for(var i = 0; i <= promoChecked.length - 1; i++){
            if(promoChecked && item.selected.toString().indexOf(promoChecked[i].id.toString()) === 0){
              flag = true; 
              break;
            } else {
              flag = false;
            }
          }
          return flag;
        }

        if (filter.restNumber && item.restNumber.toString().indexOf(filter.restNumber) === -1 ||
        (filter.restNumber && !item.restNumber)) {
          return false;
        }
        if (filter.nodeName && item.nodeName && item.nodeName.toLowerCase().indexOf(filter.nodeName.toLowerCase()) === -1 ||
        (filter.nodeName && !item.nodeName)) {
          return false;
        }
        if (filter.promoCode && item.promoCode.toString().indexOf(filter.promoCode) === -1 ||
        (filter.promoCode && !item.promoCode)) {
          return false;
        }
        if (filter.promoName && item.promoName && item.promoName.toLowerCase().indexOf(filter.promoName.toLowerCase()) === -1 ||
        (filter.promoName && !item.promoName)) {
          return false;
        }
        if (filter.promoLongDesc && item.promoLongDesc && item.promoLongDesc.toLowerCase().indexOf(filter.promoLongDesc.toLowerCase()) === -1 ||
        (filter.promoLongDesc && !item.promoLongDesc)) {
          return false;
        }
        if (filter.promoTemplateLabel && item.templateName && item.templateName.toLowerCase().indexOf(filter.promoTemplateLabel.toLowerCase()) === -1 ||
        (filter.promoTemplateLabel && !item.templateName)) {
          return false;
        }
         if (filter.strtDate && item.promotionDateFrom && item.promotionDateFrom.toLowerCase().indexOf(filter.strtDate.toLowerCase()) === -1 ||
         (filter.strtDate && !item.promotionDateFrom)) {
           return false;
         }
         if (filter.endDate && item.promotionDateTo && item.promotionDateTo.toLowerCase().indexOf(filter.endDate.toLowerCase()) === -1 ||
          (filter.endDate && !item.promotionDateTo)) {
           return false;
        }
        if (filter.promoStatus && item.promoStatus && item.promoStatus.toLowerCase().indexOf(filter.promoStatus.toLowerCase()) === -1 ||
        (filter.promoStatus && !item.promoStatus)) {
          return false;
        }
        return true;
      });
    } else {
      return items;
    }
  }
}
